import React from "react";
import { useStyles } from "./AboutImage.styles";
interface Props {}

export const AboutImage: React.FC<Props> = () => {
  const classes = useStyles();
  return <div className={classes.aboutImage_root}>About Image</div>;
};
